/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-02-15 11:38:46
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-02-15 13:43:15
 * @FilePath: \xm-integration-refactor\src\views\dataEmployeesDes\store\des-editor.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export type MenuProps = {
  showMenu: boolean,
  menusAll:Array<any>,
  activeMenuKey:string,
  subMenus:Array<any>,
  mainMenu:Array<any>,
}

export const useMenuStore = defineStore({
  id: 'menu-store',
  state: () => {
    return {
      activeMenuId:'',
      menuProps: {
        mainMenu:[],
        subMenus:[],
        menusAll:[],
        activeMenuKey:'',
        showMenu: false,
      } as MenuProps,
      readonly: false
    }
  }
})
